import { Component, escapeHtml, register } from './core.js';
import { cx, mountRoot, bindActions } from './chrome.js';
import { buttonHtml } from './button.js';
import { badgeHtml } from './badge.js';

const DEFAULTS = { title: '', level: 2, subtitle: '', count: null, actions: [], onAction: null };

/** Shared markup builder for SectionHeader (live and static). */
export function sectionHeaderHtml(opts) {
	const o = Object.assign({}, DEFAULTS, opts);
	const level = Math.min(4, Math.max(2, Math.round(Number(o.level)) || 2));
	const actions = Array.isArray(o.actions) ? o.actions : [];
	const hasCount = o.count !== null && o.count !== undefined && o.count !== '';
	return `<div class="${cx('dfc', 'dfc-section-header', o.className)}">`
		+ '<div class="dfc-section-header-main">'
		+ `<div class="dfc-section-header-line"><h${level} class="dfc-section-header-title">${escapeHtml(o.title)}</h${level}>`
		+ (hasCount ? badgeHtml({ text: String(o.count), tone: 'neutral', size: 'sm', className: 'dfc-section-header-count' }) : '')
		+ '</div>'
		+ (o.subtitle ? `<p class="dfc-section-header-subtitle">${escapeHtml(o.subtitle)}</p>` : '')
		+ '</div>'
		+ (actions.length ? `<div class="dfc-section-header-actions">${actions.map((a) => buttonHtml({ label: a.label, icon: a.icon, variant: a.variant || 'secondary', size: 'sm', action: a.id })).join('')}</div>` : '')
		+ '</div>';
}

/**
 * SectionHeader: a real heading (h2..h4) with optional subtitle, count badge and action buttons.
 *
 * new dfc.SectionHeader(container, { title, level: 2 | 3 | 4, subtitle, count,
 *   actions: [{ id, label, icon, variant }], onAction })
 * Events: action { id, event }
 * Static: dfc.SectionHeader.renderStatic(opts) -> HTML string
 */
export class SectionHeader extends Component {
	static get componentName() { return 'section-header'; }
	defaults() { return Object.assign({}, DEFAULTS); }
	render() { mountRoot(this, sectionHeaderHtml(this.options)); bindActions(this); }
	static renderStatic(opts = {}) { return sectionHeaderHtml(opts); }
}

register('sectionheader', SectionHeader);
